import { useEffect } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import WebFont from 'webfontloader';
import './App.scss';
import { baseAppPath, baseRetiredAppPath } from './config/GlobalConfig';
import { ALL_INFO_STEPS, APP_RETIREMENT_URLS, APP_URLS } from './const/AppConst';
import { AppProvider } from './context/AppContext';
import BaseLayoutPage from './pages/BaseLayoutPage';
import BienvenuePage from './pages/BienvenuePage';
import Error404Page from './pages/Error404Page';
import InfoPersoStep0Page from './pages/InfoPersoStep0Page';
import InfoPersoStep1Page from './pages/InfoPersoStep1Page';
import InfoPersoStep2Page from './pages/InfoPersoStep2Page';
import InfoPersoStep3Page from './pages/InfoPersoStep3Page';
import InfoPersoStep4Page from './pages/InfoPersoStep4Page';
import InfoPersoStep5Page from './pages/InfoPersoStep5Page';
import LoginPage from './pages/LoginPage';
import { useAddRizChat } from './hooks/useAddRizChat';
import ProtectedRoute, { ProtectedRouteProps } from './routers/ProtectedRoute';
import EndPage from './pages/EndPage';
import RecapPage from './pages/RecapPage';
import InfoSignatureStep0Page from "./pages/InfoSignatureStep0Page";
import InfoSignatureStep1Page from './pages/InfoSignatureStep1Page';
import InfoSignatureStep2Page from './pages/InfoSignatureStep2Page';
import UploadMobileDocPage from './pages/UploadMobileDocPage';
import UploadMobileConfirmPage from './pages/UploadMobileConfirmPage';
import { useFetchNomenclature } from './hooks/useFetchNomenclature';
import InfoPersoStep6Page from './pages/InfoPersoStep6Page';
import InfoPersoStep7Page from './pages/InfoPersoStep7Page';
import InfoBeneficiaryStep0Page from './pages/InfoBeneficiaryStep0Page';
import InfoBeneficiaryStep1Page from './pages/InfoBeneficiaryStep1Page';
import InfoBeneficiaryStep2Page from './pages/InfoBeneficiaryStep2Page';
import InfoOptionsPage from './pages/InfoOptionsPage';
import ListInvalidDocumentPage from './pages/ListInvalidDocumentPage';
import UploadDocumentPage from './pages/UploadDocumentPage';
import InfoModificationPage from './pages/InfoModificationPage';
import ConfirmModificationPage from './pages/ConfirmModificationPage';
import PostSignatureActionPage from './pages/PostSignatureActionPage';
import GuarantyPage from './pages/GuarantyPage';
import cmsClient from './services/BaseCmsService';
import { ApolloProvider } from '@apollo/react-hooks';
import InfoPersoRecapPage from './pages/InfoPersoRecapPage';
import FamilyDocumentsPage from './pages/FamilyDocumentsPage';

import REBienvenueRetirementPage from './pages/retirement/REBienvenueRetirementPage';
import RESituationPage from './pages/retirement/RESituationPage';
import REBesoinPage from './pages/retirement/REBesoinPage';
import REGuarantyRetirementPage from './pages/retirement/REGuarantyRetirementPage';
import REInfoIdentityPage from './pages/retirement/REInfoIdentityPage';
import REInfoAddressPage from './pages/retirement/REInfoAddressPage';
import REInfoContactPage from './pages/retirement/REInfoContactPage';
import REInfoOldContractPage from './pages/retirement/REInfoOldContractPage';
import REInfoBankPage from './pages/retirement/REInfoBankPage';
import REInfoRetirementDocPage from './pages/retirement/REInfoRetirementDocPage';
import REInfoAttestationROPage from './pages/retirement/REInfoAttestationROPage';
import REInfoAttestationROBeneficiaryPage from './pages/retirement/REInfoAttestationROBeneficiaryPage';
import REInfoBeneficiaryPage from './pages/retirement/REInfoBeneficiaryPage';
import REInfoIdentityDocPage from './pages/retirement/REInfoIdentityDocPage';
import REInfoFamilyDocPage from './pages/retirement/REInfoFamilyDocPage';
import REInfoLastEmployeeDocPage from './pages/retirement/REInfoLastEmployeeDocBloc';
import RERecapRetirementPage from './pages/retirement/RERecapRetirementPage';
import REInfoSignatureDocumentPage from './pages/retirement/REInfoSignatureDocumentPage';
import REInfoSignatureConfirmPage from './pages/retirement/REInfoSignatureConfirmPage';
import REInfoSignatureDonePage from './pages/retirement/REInfoSignatureDonePage';
import RELoginPage from './pages/retirement/RELoginPage';
import REEndPage from './pages/retirement/REEndPage';
import InfoOldContractPage from './pages/InfoOldContractPage';
import SubscriptionPage from './pages/subscription/SubscriptionPage';
import REPostSignatureActionPage from './pages/retirement/REPostSignatureActionPage';
import REConfirmModificationPage from './pages/retirement/REConfirmModificationPage';
import REInfoModificationPage from './pages/retirement/REInfoModificationPage';
import REListInvalidDocumentPage from './pages/retirement/REListInvalidDocumentPage';
import REUploadDocumentPage from './pages/retirement/REUploadDocumentPage';



function App() {
  const location = useLocation();

  const title = ALL_INFO_STEPS.find(el => el.path === location.pathname)?.label ?? 'Parcours d\'adhésion au contrat collectif MGP'
  useEffect(() => {
    WebFont.load({
      custom: {
        families: ['Graphik', 'mgp-icons'],
        urls: [process.env.REACT_APP_RESSOURCE_BASE_URL + '/fonts/fonts.css']
      },
      
    });
    document.title = title
   
   }, [location]);

   // Load nomenclatures
   useFetchNomenclature("country", true);
   useFetchNomenclature("department", true);
   useFetchNomenclature("familySituation");
   useFetchNomenclature("civility");


   const defaultProtectedRouteProps: Omit<ProtectedRouteProps, 'outlet'> = {
  };
  useAddRizChat();

  return (
    <section>
      <Routes>
        <Route path={APP_URLS.validatePage} element={<LoginPage /> } />
        <Route path={baseAppPath} element={<BaseLayoutPage/>}>
          <Route index element={<Navigate to={APP_URLS.error404Page} />} />
          <Route path={APP_URLS.bienvenuePage} element={<ProtectedRoute {...defaultProtectedRouteProps} outlet={<BienvenuePage />} />} />
          <Route path={APP_URLS.infoPersoStep0Page} element={<ProtectedRoute {...defaultProtectedRouteProps} outlet={<InfoPersoStep0Page />} />} />
          <Route path={APP_URLS.infoPersoStep1Page} element={<ProtectedRoute {...defaultProtectedRouteProps} outlet={<InfoPersoStep1Page />} />} />
          <Route path={APP_URLS.infoPersoStep2Page} element={<ProtectedRoute {...defaultProtectedRouteProps} outlet={<InfoPersoStep2Page />} />} />
          <Route path={APP_URLS.infoPersoStep3Page} element={<ProtectedRoute {...defaultProtectedRouteProps} outlet={<InfoPersoStep3Page />} />} />
          <Route path={APP_URLS.infoPersoStep4Page} element={<ProtectedRoute {...defaultProtectedRouteProps} outlet={<InfoPersoStep4Page />} />} />
          <Route path={APP_URLS.infoPersoStep5Page} element={<ProtectedRoute {...defaultProtectedRouteProps} outlet={<InfoPersoStep5Page />} />} />
          <Route path={APP_URLS.infoPersoStep6Page} element={<ProtectedRoute {...defaultProtectedRouteProps} outlet={<InfoPersoStep6Page />} />} />
          <Route path={APP_URLS.infoPersoStep7Page} element={<ProtectedRoute {...defaultProtectedRouteProps} outlet={<InfoPersoStep7Page />} />} />
          <Route path={APP_URLS.infoPersoRecapPage} element={<ProtectedRoute {...defaultProtectedRouteProps} outlet={<InfoPersoRecapPage />} />} />
          <Route path={APP_URLS.infoBeneficiaryStep0Page} element={<ProtectedRoute {...defaultProtectedRouteProps} outlet={<InfoBeneficiaryStep0Page />} />} />
          <Route path={APP_URLS.infoBeneficiaryStep1Page} element={<ProtectedRoute {...defaultProtectedRouteProps} outlet={<InfoBeneficiaryStep1Page />} />} />
          <Route path={APP_URLS.infoBeneficiaryStep2Page} element={<ProtectedRoute {...defaultProtectedRouteProps} outlet={<InfoBeneficiaryStep2Page />} />} />
          <Route path={APP_URLS.infoSignatureStep1Page} element={<ProtectedRoute {...defaultProtectedRouteProps} outlet={<InfoSignatureStep1Page />} />} />
          <Route path={APP_URLS.recapPage} element={<ProtectedRoute {...defaultProtectedRouteProps} outlet={<RecapPage />} />} />
          <Route path={APP_URLS.infoSignatureStep0Page} element={<ProtectedRoute {...defaultProtectedRouteProps} outlet={<InfoSignatureStep0Page />} />} />
          <Route path={APP_URLS.infoSignatureStep2Page} element={<ProtectedRoute {...defaultProtectedRouteProps} outlet={<InfoSignatureStep2Page />} />} />
          <Route path={APP_URLS.uploadMobileDocPage} element={<UploadMobileDocPage/>} />
          <Route path={APP_URLS.uploadMobileConfirmPage} element={<UploadMobileConfirmPage/>} />
          <Route path={APP_URLS.infoOptionsPage} element={<InfoOptionsPage/>} />
          <Route path={APP_URLS.listInvalidDocumentPage} element={<ProtectedRoute {...defaultProtectedRouteProps} outlet={<ListInvalidDocumentPage />} />} />
          <Route path={APP_URLS.uploadDocumentPage} element={<ProtectedRoute {...defaultProtectedRouteProps} outlet={<UploadDocumentPage />} />} />
          <Route path={APP_URLS.infoModificationPage} element={<ProtectedRoute {...defaultProtectedRouteProps} outlet={<InfoModificationPage />} />} />
          <Route path={APP_URLS.confirmModificationPage} element={<ProtectedRoute {...defaultProtectedRouteProps} outlet={<ConfirmModificationPage />} />} />
          <Route path={APP_URLS.postSignatureActionPage} element={<ProtectedRoute {...defaultProtectedRouteProps} outlet={<PostSignatureActionPage />} />} />
          <Route path={APP_URLS.guarantyPage} element={<ProtectedRoute {...defaultProtectedRouteProps} outlet={<GuarantyPage />} />} />
          <Route path={APP_URLS.familyDocumentsPage} element={<ProtectedRoute {...defaultProtectedRouteProps} outlet={<FamilyDocumentsPage />} />} />
          <Route path={APP_URLS.infoOldContractPage} element={<ProtectedRoute {...defaultProtectedRouteProps} outlet={<InfoOldContractPage />} />} />
          <Route path={APP_URLS.endPage} element={<ProtectedRoute {...defaultProtectedRouteProps} outlet={<EndPage />} />} />
          <Route path="*" element={<Navigate to={APP_URLS.error404Page} />} />
        </Route>
      
        <Route path={APP_URLS.error404Page} element={<Error404Page/>} />
        <Route path="*" element={<Navigate to={APP_URLS.error404Page} />} />
        <Route path={baseRetiredAppPath} element={<BaseLayoutPage/>}>
          <Route path={APP_RETIREMENT_URLS.bienvenuePage} element={<REBienvenueRetirementPage />} />
          <Route path={APP_RETIREMENT_URLS.situationPage} element={<RESituationPage />} />
          <Route path={APP_RETIREMENT_URLS.besoinPage} element={<REBesoinPage />} />
          <Route path={APP_RETIREMENT_URLS.guarantyPage} element={<REGuarantyRetirementPage />} />
          <Route path={APP_RETIREMENT_URLS.infoIdentityPage} element={<REInfoIdentityPage />} />
          <Route path={APP_RETIREMENT_URLS.infoAddressPage} element={<REInfoAddressPage />} />
          <Route path={APP_RETIREMENT_URLS.infoContactPage} element={<REInfoContactPage />} />
          <Route path={APP_RETIREMENT_URLS.infoOldContractPage} element={<REInfoOldContractPage />} />
          <Route path={APP_RETIREMENT_URLS.infoBankPage} element={<REInfoBankPage />} />
          <Route path={APP_RETIREMENT_URLS.infoAttestationROPage} element={<REInfoAttestationROPage />} />
          <Route path={APP_RETIREMENT_URLS.infoAttestationROBeneficiaryPage} element={<REInfoAttestationROBeneficiaryPage />} />
          <Route path={APP_RETIREMENT_URLS.infoBeneficiaryPage} element={<REInfoBeneficiaryPage />} />
          <Route path={APP_RETIREMENT_URLS.infoIdentityDocPage} element={<REInfoIdentityDocPage />} />
          <Route path={APP_RETIREMENT_URLS.infoRetirementDocPage} element={<REInfoRetirementDocPage />} />
          <Route path={APP_RETIREMENT_URLS.infoLastEmployeeDocPage} element={<REInfoLastEmployeeDocPage />} />
          <Route path={APP_RETIREMENT_URLS.infoFamilyDocPage} element={<REInfoFamilyDocPage />} />
          <Route path={APP_RETIREMENT_URLS.retirementRecapPage} element={<RERecapRetirementPage />} />
          <Route path={APP_RETIREMENT_URLS.infoSignatureDocumentPage} element={<REInfoSignatureDocumentPage />} />
          <Route path={APP_RETIREMENT_URLS.infoSignatureConfirmPage} element={<REInfoSignatureConfirmPage />} />
          <Route path={APP_RETIREMENT_URLS.infoSignatureDonePage} element={<REInfoSignatureDonePage />} />
          <Route path={APP_RETIREMENT_URLS.listInvalidDocumentPage} element={<ProtectedRoute {...defaultProtectedRouteProps} outlet={<REListInvalidDocumentPage />} />} />
          <Route path={APP_RETIREMENT_URLS.uploadDocumentPage} element={<ProtectedRoute {...defaultProtectedRouteProps} outlet={<REUploadDocumentPage />} />} />
          <Route path={APP_RETIREMENT_URLS.infoModificationPage} element={<ProtectedRoute {...defaultProtectedRouteProps} outlet={<REInfoModificationPage />} />} />
          <Route path={APP_RETIREMENT_URLS.confirmModificationPage} element={<ProtectedRoute {...defaultProtectedRouteProps} outlet={<REConfirmModificationPage />} />} />
          <Route path={APP_RETIREMENT_URLS.postSignatureActionPage} element={<ProtectedRoute {...defaultProtectedRouteProps} outlet={<REPostSignatureActionPage />} />} />
          <Route path={APP_RETIREMENT_URLS.endPage} element={<REEndPage />} />

        </Route>
        <Route path={APP_RETIREMENT_URLS.validatePage} element={<RELoginPage /> } />
        <Route path={APP_URLS.subscriptionPage} element={<SubscriptionPage /> } />
      </Routes>
    </section>
    
  );
}

export default () => (
  <ApolloProvider client={cmsClient}>
    <AppProvider>
      <App />
    </AppProvider>
  </ApolloProvider>
);
